import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom'

const ignoredUrls = ['mc.yandex.ru', 'analytics.google.com']

const initializeSentry = () => {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      }),
      Sentry.extraErrorDataIntegration({
        depth: 100
      })
    ],
    normalizeDepth: 10,
    tracesSampleRate: 1.0,
    environment: 'production',
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category === 'fetch' && breadcrumb.data?.url && breadcrumb.data?.url.includes(ignoredUrls)) {
        return null
      }
      return breadcrumb
    }
  })
}

export { initializeSentry }
